import React, {useState} from 'react';
import {Helmet} from 'react-helmet';
import {Modal} from 'reactstrap';
import ConsentManager from '../../../ConsentManager/ConsentManager';
import Cookies from 'js-cookie';
import {personalization, statisticTracking} from "../../../../shared/trackingScripts";

const ConsentModal = (props) => {
    const [modal, setModal] = useState(true);
    const [statisticScript, setStatisticScript] = useState('');
    const [personalizationScript, setPersonalizationScript] = useState('');

    const toggle = () => {
        setModal(!modal);
    };

    const statisticHandler = () => {
        let script = statisticTracking();
        setStatisticScript(script);
        Cookies.set('bigfoot_statistic-consent', true, {expires: 180});
    };

    const personalizationHandler = () => {
        let script = personalization();
        setPersonalizationScript(script);
        Cookies.set('bigfoot_personalization-consent', true, {expires: 180});
    };

    const consentCallback = (consentState) => {
        // check if user clicked the accept all button
        if (Object.values(consentState).every(Boolean)) {
            // turn everything on:
            statisticHandler();
            personalizationHandler();
        }
        // user has clicked the selection button, therefore check the state of selection:
        else {
            if (consentState.statisticCheck) {
                if (consentState.personalizationCheck) {
                    statisticHandler();
                    personalizationHandler();
                } else if (consentState.performanceCheck) {
                    statisticHandler();
                    // this.performanceHandler();
                } else {
                    statisticHandler();
                }
            } else if (consentState.personalizationCheck) {
                Cookies.set('bigfoot_statistic-consent', false, {expires: 180});
                if (consentState.performanceCheck) {
                    personalizationHandler();
                    // this.performanceHandler();
                } else {
                    personalizationHandler();
                }
            } else {
                Cookies.set('bigfoot_statistic-consent', false, {expires: 180});
                Cookies.set('bigfoot_personalization-consent', false, {expires: 180});
                // only performance is selected, the other options are already checked.
                // this.performanceHandler();
            }
        }
        toggle();
    };

    return (
        <React.Fragment>
            <Helmet>{statisticScript}</Helmet>
            <Modal size="lg" scrollable backdrop={'static'} keyboard={false} isOpen={modal} toggle={toggle}>
                <ConsentManager consentCallback={consentCallback} pages={props.pages}/>
            </Modal>
        </React.Fragment>
    );
};

export default ConsentModal;
